import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { observer, inject, PropTypes as MobXPropTypes } from 'mobx-react';
import { PageHeader } from 'react-bootstrap';
import { withErrorBoundary } from 'react-error-boundary';
import { withTranslation } from 'react-i18next';
import { handleError } from '../../../services/ErrorService';
import GenericViewError from '../../../components/Error/GenericViewError';
import ViewLoader from '../../../components/Loading/View';
import Store from './store';

const NotificationList = React.lazy(() =>
  import(
    /* webpackChunkName: 'notifications-list' */ '../../../components/Notifications/List'
  ),
);

@withTranslation()
@inject('routerStore')
@observer
class NotificationListView extends Component {
  static propTypes = {
    routerStore: MobXPropTypes.observableObject.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { routerStore } = this.props;
    const { title } = routerStore?.route?.params;

    this.store = new Store();
    this.title = title;
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    this.store.getNotifications();
  };

  render() {
    const { t } = this.props;
    const { notifications } = this.store;
    const { title } = this;

    return (
      <>
        <Helmet title={`${t(title)} - Red Hat Learning`} />
        <React.Suspense fallback={<ViewLoader />}>
          <div className="container-grid-responsive">
            <PageHeader>{t(title)}</PageHeader>
            <NotificationList notifications={notifications} />
          </div>
        </React.Suspense>
      </>
    );
  }
}

export default withErrorBoundary(
  NotificationListView,
  GenericViewError,
  handleError,
);
